<template>
  <div class="menu-item-r">
    <div class="dash-form-container my-employee-list">
      <div class="v-nav-wrap">
        <el-button
          class="el-button--primary-empty"
          type="primary"
          size="small"
          @click="$router.push('/add-employee')"
          >{{ $t('Add Employee') }}</el-button
        >
      </div>

      <div class="employee-list flex-start">
        <EmployeeCard
          v-on:callback="handleOperation"
          v-for="item in employeeList"
          :key="item.id"
          :employee="item"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getEmployeeList, delEmployee } from '@/api'
import EmployeeCard from '@/components/DashEmployeeCard'
export default {
  name: 'MyEmployeeList',

  components: {
    EmployeeCard
  },

  data() {
    return {
      employeeList: []
    }
  },

  computed: {
    ...mapGetters(['info']),
    noAdmin() {
      return (
        !this.info ||
        (this.info && !this.info.exhibitorEmployee) ||
        (this.info &&
          this.info.exhibitorEmployee &&
          !this.info.exhibitorEmployee.admin)
      )
    }
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (vm.noAdmin) {
        vm.$router.replace('/')
      }
    })
  },

  mounted() {
    if (!this.noAdmin) {
      this.getList()
    }
  },
  methods: {
    getList() {
      const loading = this.$loading()
      getEmployeeList({})
        .then(res => {
          this.employeeList = res.data.data
        })
        .finally(() => {
          loading.close()
        })
    },

    handleOperation(action) {
      if (action.type === 'edit') {
        this.$store.commit('setEmployeeDetail', action.data.employee)
        this.$router.push(`/employee/${action.data.employee.id}`)
      }

      if (action.type === 'del') {
        this.$alert(
          this.$t('Are you sure detele this item2?'),
          this.$t('Confirm'),
          {
            showCancelButton: true,
            callback: _action => {
              if (_action === 'confirm') {
                delEmployee({
                  id: action.data.employee.id,
                  userAccountId: action.data.employee.userAccountId
                }).then(() => {
                  this.getList()
                })
              }
            }
          }
        )
      }
    }
  }
}
</script>
<style lang="stylus">
.employee-list
  flex-wrap wrap
</style>
